import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Slide, toast, ToastContainer } from 'react-toastify';
import { Subject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { ToastMessage, ToastStyles } from '../../models/Index';

type Props = {
  notification$: Subject<ToastMessage>;
  styles: ToastStyles;
};

function Notification(props: Props) {
  const [t] = useTranslation();

  useEffect(() => {
    const toastStyles = props.styles;
    const toastMessage$ = props.notification$
      .pipe(
        distinctUntilChanged(
          (prev: ToastMessage, curr: ToastMessage) => prev.source === curr.source && curr.source !== 'CUSTOMER_SETTINGS.SEND_DEMO_TOAST',
        ),
      )
      .subscribe((message) => {
        const msg =
          message.text instanceof Object
            ? JSON.stringify(message.text)
            : (message.text as string).includes('TOAST_MESSAGE.')
            ? t(message.text)
            : message.text;
        toast[message.type](msg, { ...toastStyles[message.type], ...message.style });
      });

    return () => {
      toastMessage$.unsubscribe();
    };
  }, [props.notification$, props.styles, t]);

  return (
    <ToastContainer
      position="top-center"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      limit={3}
      transition={Slide}
      theme="colored"
    />
  );
}

export default Notification;
